// Import polyfills first
import './lib/polyfills';

import { createRoot } from 'react-dom/client';
import React from 'react';
import App from './App';
import './index.css';

// Safe error handler — uses textContent / DOM APIs to prevent XSS
const errorHandler = (error: any) => {
  console.error('Application Error:', error);

  const errorContainer = document.createElement('div');
  errorContainer.style.padding = '20px';
  errorContainer.style.margin = '20px';
  errorContainer.style.backgroundColor = '#300';
  errorContainer.style.color = 'white';
  errorContainer.style.fontFamily = 'monospace';

  const heading = document.createElement('h2');
  heading.textContent = 'Application Error';
  errorContainer.appendChild(heading);

  const msg = document.createElement('p');
  msg.textContent = error?.message ?? String(error);
  errorContainer.appendChild(msg);

  if (error?.stack) {
    const pre = document.createElement('pre');
    pre.textContent = error.stack;
    errorContainer.appendChild(pre);
  }

  const btn = document.createElement('button');
  btn.textContent = 'Reload';
  btn.style.cssText =
    'background:#f0f0f0; color:#000; padding:8px 16px; border:none; border-radius:4px; margin-top:15px; cursor:pointer';
  btn.addEventListener('click', () => window.location.reload());
  errorContainer.appendChild(btn);

  document.body.replaceChildren(errorContainer);
};

try {
  console.log('Application starting...');
  const rootElement = document.getElementById('root');

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = createRoot(rootElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  console.log('Application rendered successfully');
} catch (error) {
  errorHandler(error);
}
